/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Redeem_LabelInputs */

const en_us2_invite_redeem_label = /** @type {(inputs: Invite_Redeem_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code`)
};

const pt_br2_invite_redeem_label = /** @type {(inputs: Invite_Redeem_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código do convite`)
};

const pt_pt2_invite_redeem_label = /** @type {(inputs: Invite_Redeem_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código do convite`)
};

/** @type {(inputs: Invite_Redeem_LabelInputs) => LocalizedString} */
const es_419_invite_redeem_label = en_us2_invite_redeem_label;

/** @type {(inputs: Invite_Redeem_LabelInputs) => LocalizedString} */
const fr_fr2_invite_redeem_label = en_us2_invite_redeem_label;

/** @type {(inputs: Invite_Redeem_LabelInputs) => LocalizedString} */
const de_de2_invite_redeem_label = en_us2_invite_redeem_label;

/** @type {(inputs: Invite_Redeem_LabelInputs) => LocalizedString} */
const it_it2_invite_redeem_label = en_us2_invite_redeem_label;

/**
* | output |
* | --- |
* | "Invite code" |
*
* @param {Invite_Redeem_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_redeem_label = /** @type {((inputs?: Invite_Redeem_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Redeem_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_redeem_label(inputs)
	if (locale === "es-419") return es_419_invite_redeem_label(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_redeem_label(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_redeem_label(inputs)
	if (locale === "de-DE") return de_de2_invite_redeem_label(inputs)
	if (locale === "it-IT") return it_it2_invite_redeem_label(inputs)
	return en_us2_invite_redeem_label(inputs)
});
export { invite_redeem_label as "invite.redeem_label" }